import type { CSSProperties } from "react"

/** Global class (see globals.css) that runs the staggered fade-in + blur-out. */
export const FLOATING_REVEAL_CLASS = "floating-reveal"

/** Places an element at `index` in the staggered reveal sequence. */
export const floatingRevealStyle = (index: number): CSSProperties =>
  ({ "--floating-reveal-index": index } as CSSProperties)
